(ns frontend.view.nev.sale-agreement.view
  (:require
   [frontend.actions.common :as common-actions]
   [reagent.core :as r]
   [potpuri.core :as p :refer [fn->]]
   [common.localization :as loc]
   [clojure.string :as string]
   [frontend.logging :as logging]
   [frontend.view.entity-viewers.header :as header]
   [frontend.view.field-templates :as templates]
   [frontend.view.nev.events :as events]
   [common.entity :as entity]
   [frontend.view.entity-viewers.entity-editor :as entity-editor]
   [frontend.view.not-found :as not-found]
   [frontend.routing :as routing]
   [frontend.view.entity-viewers.event-pane :as event-pane]
   [frontend.view.entity-viewers.modules :as modules]
   [frontend.state.current-session :as session]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.view.entity-viewers.utils :as entity-utils]
   [frontend.view.syncing-data :as syncing]
   [frontend.db :as app-db]
   [frontend.view.entity-viewers.components :as nev-components]
   [common.schema.field :as field]
   [common.schema.assets :as assets]
   [frontend.utils :as fu]
   [frontend.view.entity-viewers.modules.associated-entities :as associated-entities]
   [frontend.state.permissions :as f-permissions]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.actions.sale-agreement :as sale-agreement-actions]))

(defn toolbar-buttons
  [{:keys [entity] :as _view-args}]
  (let [entity-id (:db/id entity)
        flagged? (contains? (:account/flagged-entities @session/account)
                            entity-id)]
    (concat
     (when-let [customer (some->> entity
                                  :sale-agreement/customer
                                  (session/get-entity))]
       (when (and (not (:customer/customer-number customer))
                  (f-permissions/field-read-access? :sale-agreement/calculated-customer-number
                                                    :entity.type/sale-agreement
                                                    nil))
         [{:toolbar-button? false
           :dropdown-action? true
           :ord       6
           :on-select (fn [_]
                        (sale-agreement-actions/*->assign-customer-number
                         {:sale-agreement-id (:db/id entity)}
                         identity
                         (fn [err]
                           (logging/error "Failed to assing customer number" err))))
           :label     (loc/tr :sale-agreement/assign-customer-number)}]))
     [(when-not (:common/disabled? entity)
        (zap-toolbar/delete-button entity [:sale-agreements-grid]))]
     [(zap-toolbar/dropdown-button
       {:icon      :fa-star
        :on-select (partial common-actions/toggle-flag entity flagged?)
        :ord       1
        :label     (loc/tr (if flagged? :unflag-entity-menu-item :flag-entity-menu-item))})]

     [(nev-components/audit-trail-button {:entity     entity
                                          :entity-ids [entity-id]})])))

(defn header-top
  [{:keys [entity read-only?]}]
  [:div
   {:class "flex gap-2"}
   [:span.entity-logo-container.icon-container
    {:style {:padding-left "0"}}
    [:i
     {:class-name (fu/cs :fal (entity/default-icon entity))}]]
   [:div.nev-name-row-container
    [nev-components/name-view
     {:entity     entity
      :read-only? read-only?}]]])

(def default-field-defs
  [])

(defn header-board
  [{:keys [_entity-atom]}]
  (let [header-state (r/atom {:edit-layout? false})
        set-edit-layout! (fn [val] (swap! header-state assoc :edit-layout? val))]
    (fn [{:keys [entity-atom]}]
      (let [entity @entity-atom
            tenant-schema @session/tenant-schema
            entity-id (:db/id entity)
            field-defs-path [:sale-agreement :header :field-defs]
            field-defs-timeout-id :sale-agreement-field-defs
            field-defs (or (events/timeout-value field-defs-timeout-id
                                                 @(r/track session/get-view-config field-defs-path))
                           default-field-defs)
            overrides nil
            selected-fields (->> field-defs
                                 (map :fields)
                                 (mapcat vals)
                                 (keep :field))
            remove-fields #{}
            sale-agreement-schema (templates/entity-type-template
                                   {:entity-type     :entity.type/sale-agreement
                                    :selected-fields selected-fields
                                    :tenant          @session/tenant
                                    :tenant-schema   tenant-schema
                                    :account         @session/account
                                    :role            @session/role
                                    :remove-fields   remove-fields
                                    :overrides       overrides})

            customer-schema
            (templates/customer-template
             {:selected-fields (->> selected-fields
                                    (filter vector?)
                                    (filter (fn-> count (= 2)))
                                    (filter (fn-> first (= :sale-agreement/customer)))
                                    (map last))
              :tenant          @session/tenant
              :tenant-schema   tenant-schema
              :account         @session/account
              :role            @session/role
              :overrides       {:investor/legal-entity {:editor/type :editor.type/link
                                                        :read-only?  true}}})

            legal-entity-schema
            (templates/legal-entity-template
             {:selected-fields (->> selected-fields
                                    (filter vector?)
                                    (filter (fn-> count (= 3)))
                                    (filter (fn-> first (= :sale-agreement/customer)))
                                    (filter (fn-> second (= :investor/legal-entity)))
                                    (map last))
              :tenant          @session/tenant
              :tenant-schema   tenant-schema
              :account         @session/account
              :role            @session/role})

            schema
            (doall
             (concat
              sale-agreement-schema
              (->> customer-schema
                   (map (fn [[k fs]]
                          ;;label "Customer (investor) - attr"
                          (let [ref-attribute [:sales-opportunity/customer k]]
                            [ref-attribute
                             (assoc fs
                                    :label
                                    (templates/customer-label tenant-schema fs))]))))
              (->> legal-entity-schema
                   (map
                    (fn [[k fs]]
                      ;;label "Customer (investor) - Legal entity (company) - attr"
                      (let [ref-attribute [:sales-opportunity/customer :investor/legal-entity k]]
                        [ref-attribute (assoc fs :label (templates/legal-entity-label fs))]))))))

            ;;test all fields:
            #_#_field-defs
              (->> schema
                   (map first)
                   (partition-all 4 4)
                   (map (fn [fields]
                          (->> fields
                               (map-indexed (fn [i f]
                                              [i {:field f}])))))
                   (map (partial into {}))
                   (map (fn [fields]
                          {:fields       fields
                           :field-layout :f-1-1-1-1}))
                   vec)]
        [:div
         [header/header-board
          {:top              [header-top {:entity entity}]
           :preview-top      [header-top
                              {:entity     entity
                               :read-only? true}]
           :actions          (toolbar-buttons {:entity entity})
           :entity-id        entity-id
           :entity-atom      entity-atom
           :edit-layout?     (:edit-layout? @header-state)
           :set-edit-layout! set-edit-layout!
           :field-defs       field-defs
           :schema           schema
           :save-layout!     (fn [new-field-defs]
                               (events/save-field-defs! field-defs-timeout-id
                                                        field-defs-path
                                                        new-field-defs
                                                        (fn [])
                                                        (fn [err]
                                                          (logging/error
                                                           "Failed to save field layout"
                                                           err))))}]]))))

(defn new-header?
  []
  (and (session/has-feature-access? :feature/customizable-nev)
       @session/customizable-nev?))

(defn sale-agreement-view
  [{:keys [sale-agreement-id _is-guest?] :as _view-args}]
  (let [state-atom (r/cursor app-db/app-state [:views :nev :sale-agreement])
        initialized? (r/atom false)
        temp-atom (r/cursor state-atom [:temp])
        view-state-atom (r/cursor state-atom [:view-state])
        error-atom (r/cursor state-atom [:error])
        notification-atom (r/cursor state-atom [:notification])
        events-pane-atom (r/cursor state-atom [:events-pane])
        entity-atom (r/cursor session/entities [sale-agreement-id])]
    (r/create-class
     {:component-did-update
      (partial entity-utils/component-did-update
               :sale-agreement-id
               (partial events/clear-errors! error-atom notification-atom))
      :component-did-mount
      (fn [_]
        (entity-utils/reset-state! state-atom sale-agreement-id
                                   {:always-fetch? (session/new-grid-2023?)})
        (reset! initialized? true))
      :component-will-unmount
      (fn [_]
        (events/clear-errors! error-atom notification-atom)
        (entity-utils/clear-state! state-atom))
      :reagent-render
      (fn [{:keys [sale-agreement-id] :as view-args}]
        (let [sale-agreement (get @session/entities sale-agreement-id)
              header-fields [:sale-agreement/overview]]
          (cond
            (not @initialized?)
            [syncing/view]
            (or (:common/disabled? sale-agreement)
                (:not-found @state-atom))
            [not-found/not-found-content]
            (:loading @state-atom)
            [syncing/view]
            :else
            (if (or (not sale-agreement)
                    (:common/disabled? sale-agreement))
              [:div " "]
              (let [tenant-schema @session/tenant-schema
                    view-id :sale-agreement
                    module-collapsed-path (fn [module-id]
                                            [view-id :modules :module-config module-id
                                             :collapsed?])]
                [:<>
                 (when-not (session/is-guest?)
                   [zap-toolbar/nev-toolbar
                    {:state           state-atom
                     :label           (partial zap-toolbar/toolbar-back
                                               [:sale-agreements-grid]
                                               (loc/tr :back-to/sale-agreements-grid))
                     :actions         (toolbar-buttons (assoc view-args
                                                              :entity
                                                              sale-agreement))
                     :dropdown-toggle [:span (loc/tr :actions)
                                       [:i.fas.fa-angle-down.ml-2]]
                     :dropdown-toggle-class-name
                     "zap-button zap-button--primary-btn actions-dropdown"}])
                 [:div.entity__container
                  (when @error-atom
                    [nev-components/error-bar error-atom])
                  (when @notification-atom
                    [nev-components/notification-bar notification-atom])

                  [:div.entity
                   [:div
                    {:class "w-full max-w-[1920px] mx-auto p-4"}
                    (if (new-header?)
                      [header-board {:entity-atom entity-atom}]
                      [nev-components/header-module
                       {:component-state temp-atom
                        :view-state      view-state-atom
                        :entity          sale-agreement
                        :selected-fields header-fields}])
                    [:div.md:grid.grid-cols-10.gap-4
                     [:div
                      {:class (if (session/event-pane-disabled?)
                                "col-span-10"
                                "col-span-10 lg:col-span-5")}
                      [:div.entity-left
                       [modules/view
                        {:view-id  view-id
                         :ordering (get-in @session/view-config [view-id :modules :ordering])
                         :save-modules-order! (partial events/save-modules-order!
                                                       (:entity/type sale-agreement))
                         :modules
                         (concat
                          [{:module-id  :sale-agreement-information
                            :header     (loc/tr :nev-module/about-this-entity-type
                                                [(string/lower-case (loc/tr :entity.type/sale-agreement))])
                            ;;TODO uncomment when finished:
                            #_:header-tools
                            #_(when (session/is-admin?)
                                [:span.entity-editor-header-settings
                                 {:on-click (fn [e]
                                              ;;open settings
                                              )}
                                 [:span (loc/tr :entity-editor/settings-label)]
                                 [:i.fal.fa-cog]])
                            :collapsed? (get-in @session/view-config
                                                (module-collapsed-path :sale-agreement-information))
                            :save-module-collapsed! (partial events/save-module-collapsed!
                                                             :entity.type/sale-agreement)
                            :content    [:div
                                         [entity-editor/view
                                          {:state-atom    state-atom
                                           :entity-id     sale-agreement-id
                                           :view-id       view-id
                                           :module-id     :sale-agreement-information
                                           :remove-fields (concat [:sale-agreement/name
                                                                   :sale-agreement/customer
                                                                   :common/network-drive :common/named-network-drives]
                                                                  (field/entity-tag-fields
                                                                   tenant-schema
                                                                   (:entity/type sale-agreement))
                                                                  header-fields)
                                           :ordering      (get-in
                                                           @session/view-config
                                                           [view-id :modules :module-config
                                                            :sale-agreement-information
                                                            :ordering])}]]}
                           (let [module-id :sales-customer
                                 sale-agreement-customer (:sale-agreement/customer sale-agreement)
                                 customer-entity-type (->> sale-agreement-customer
                                                           (get @session/entities)
                                                           :entity/type)
                                 order-config-path [view-id :modules :module-config
                                                    module-id :ordering]
                                 module-label (if sale-agreement-customer
                                                (loc/tr :nev-module/existing-sales-customer
                                                        [(loc/tr customer-entity-type)])
                                                (loc/tr :nev-module/sale-agreement-customer))
                                 collapsed-path (module-collapsed-path module-id)
                                 collapsed? (get-in @session/view-config collapsed-path)
                                 header-tools (when (and sale-agreement-customer
                                                         (not collapsed?)
                                                         (not (session/is-read-only-user?)))
                                                [:span.grow.flex.justify-end
                                                 [nev-components/remove-attribute-icon
                                                  {:entity    sale-agreement
                                                   :attribute :sale-agreement/customer}]])]
                             (nev-components/entity-relation-module
                              {:state-atom          state-atom
                               :module-id           module-id
                               :view-id             view-id
                               :ordering            (get-in
                                                     @session/view-config
                                                     order-config-path)
                               :order-config-path   order-config-path
                               :module-label        module-label
                               :entity              sale-agreement
                               :header-tools        header-tools
                               :override-editor-types (when (= :entity.type/person
                                                               customer-entity-type)
                                                        {:person/name :editor.type/link})
                               :forced-entity-types (or (some->> @session/all-sales-oppo-pipelines
                                                                 (mapcat
                                                                  :pipeline/target-asset-types)
                                                                 (filterv assets/customer-types-set)
                                                                 (distinct))
                                                        []) ;; empty list as not to crash the app if pipeline is not found for any reason
                               :relationship-attribute :sale-agreement/customer}))]
                          (when-not (session/is-guest?)
                            (associated-entities/modules
                             {:entity-id sale-agreement-id
                              :save-module-collapsed! events/save-module-collapsed!
                              :module-collapsed-path module-collapsed-path}))
                          [(when (session/has-feature-access? :feature/entity-esign)
                             (let [module-id :entity-esign]
                               (nev-components/entity-esign-module
                                {:view-id view-id
                                 :module-id module-id
                                 :module-label       (loc/tr :nev-module/entity-esign)
                                 :entity             sale-agreement})))]
                          [(when (and (not (session/is-mobile?))
                                      (f-permissions/field-read-access? :common/attachments
                                                                        :entity.type/sale-agreement
                                                                        nil))
                             (nev-components/attachments-module view-id
                                                                :sale-agreement-attachments
                                                                sale-agreement))])}]]]
                     (when-not (session/event-pane-disabled?)
                       [:div
                        {:class "col-span-10 lg:col-span-5"}
                        [event-pane/view
                         {:state       events-pane-atom
                          :entity-ids  [sale-agreement-id]
                          :module-args {:state-atom state-atom
                                        :view-id    view-id}}]])]]]]])))))})))

(defmethod routing/render-view :entity.type/sale-agreement
  [{:keys [route-params _view-params]}]
  (let [sale-agreement-id (-> route-params
                              :id
                              js/parseInt)]
    [default-page-layout/view
     {:class-name "zap-page sale-agreement"}
     ;;the key change forces rerendering of the component (and its child components)
     ^{:key (str "sale-agreement-viewer-id-" sale-agreement-id)}
     [sale-agreement-view {:sale-agreement-id sale-agreement-id}]]))
